export default __webpack_public_path__ + "media/images/brands/tefal-b435e6146afa8823958d9758ff13b8fb.png";